module.exports = __webpack_public_path__ + "img/bz.fb56b21.svg";